import React from 'react';
import './Contact.scss';

class Contact extends React.Component {
    render() {
        return <div className='contacttContainer'>
            <strong>Glimma Fastigheter AB</strong><br /> <br />
            <div className='top'>
                <strong>Alingsås</strong><br /><br />

                E-mail: berith.olsson@hotmail.com<br />

                Telefonnummer: 0709 56 25 70<br />
                <br />
                Postadress:<br />
                Bagaregatan 7<br />
                441 35 ALINGSÅS<br />
            </div>
            <br />
            -----------------------------------------------------------
            <br />
            <div className='top'>
                <strong>Borås</strong><br /><br />

                E-mail: magnus.wangvik@hotmail.com<br />

                Telefontid mellan kl 17:00 - 19:00<br />Telefonnummer: 0706 93 31 14<br /><br />

                Postadress:<br />
                Pralingatan 2<br />
                441 55 ALINGSÅS<br />
            </div>
            <br />
            -----------------------------------------------------------
            <br />
            <div className='top'>
                <strong>Vänersborg</strong><br /><br />

                E-mail: stefan.wangvik@hotmail.com<br />

                Telefontid mellan kl 17:00 - 19:00<br />Telefonnummer: 0705 97 19 45<br /><br />

                Postadress:<br />
                Alströmersgatan 2<br />
                441 31 ALINGSÅS<br />
            </div>
        </div>
    }
}

export default Contact